const fromAssetIdsSelectorDefinition = {
    id: 'fromAssetIds',
    resultFunction: (exchangeableAssets) => {
        return exchangeableAssets.fromAssetIds;
    },
    dependencies: [{ selector: 'exchangeableAssets' }],
};
const isFromAssetExchangeableSelectorDefinition = {
    id: 'isFromAssetExchangeable',
    resultFunction: (exchangeableAssets) => (assetTicker) => {
        if (!assetTicker)
            throw new Error('expected assetTicker');
        return exchangeableAssets.fromAssetIds.includes(assetTicker);
    },
    dependencies: [{ selector: 'exchangeableAssets' }],
};
const toAssetIdsSelectorDefinition = {
    id: 'toAssetIds',
    resultFunction: (exchangeableAssets) => {
        return exchangeableAssets.toAssetIds;
    },
    dependencies: [{ selector: 'exchangeableAssets' }],
};
const isToAssetExchangeableSelectorDefinition = {
    id: 'isToAssetExchangeable',
    resultFunction: (exchangeableAssets) => (assetTicker) => {
        if (!assetTicker)
            throw new Error('expected assetTicker');
        return exchangeableAssets.toAssetIds.includes(assetTicker);
    },
    dependencies: [{ selector: 'exchangeableAssets' }],
};
const exchangeableAssetsSelectors = [
    fromAssetIdsSelectorDefinition,
    isFromAssetExchangeableSelectorDefinition,
    toAssetIdsSelectorDefinition,
    isToAssetExchangeableSelectorDefinition,
];
export default exchangeableAssetsSelectors;
